<mat-form-field [formGroup]="parentFormGroup">
  <mat-grid-list cols="12" rowHeight="17px">
    <mat-grid-tile [colspan]="eraseSelectionEnabled && elementControl.value ? 11 : 12">
      <mat-select #matSelect [formControlName]="parentFormControlName" [placeholder]="placeHolderLabel">
        <mat-select-trigger>
          <ng-container *ngIf="getSelectedElement()" [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{element:getSelectedElement()}"></ng-container>
        </mat-select-trigger>
        <mat-option [ngStyle]="{color: 'white'}">
          <ngx-mat-select-search
                  [noEntriesFoundLabel]="searching ? '' : noEntriesFoundLabel"
                  placeholderLabel="Rechercher..."
                  [formControl]="filterCtrl"
                  [clearSearchInput]="true"
                  [searching]="searching"
                  [hideClearSearchButton]="false"
                  [enableClearOnEscapePressed]="true"
          >
          </ngx-mat-select-search>
        </mat-option>
        <mat-option  class="new-item" *ngIf="newItemModalOptions || showNewItem" (click)="newItemSelected()">
            <span style="color: black;">
                <mat-icon>add_circle_outline</mat-icon><span>{{newItemLabel}}</span>
            </span>
        </mat-option>
        <mat-option *ngFor="let element of elements" [value]="extractValue(element)" (click)="itemSelected(element)" [text-overflow]="['',-1, '']">
          <ng-container [ngTemplateOutlet]="template" [ngTemplateOutletContext]="{element:element}" ></ng-container>
        </mat-option>
      </mat-select>
    </mat-grid-tile>
    <mat-grid-tile *ngIf="eraseSelectionEnabled && elementControl.value" colspan="1">
      <button mat-icon-button (click)="eraseSelection()">
        <mat-icon>delete</mat-icon>
      </button>
    </mat-grid-tile>
  </mat-grid-list>
  <mat-error *ngFor="let errorKey of errorsKey()">
    {{extractErrorMessage(errorKey)}}
  </mat-error>
</mat-form-field>

